import { render, staticRenderFns } from "./EquoMercato.vue?vue&type=template&id=eaff8b24"
import script from "./EquoMercato.vue?vue&type=script&lang=js"
export * from "./EquoMercato.vue?vue&type=script&lang=js"
import style0 from "./EquoMercato.vue?vue&type=style&index=0&id=eaff8b24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports